import { useEffect, useMemo } from 'react';
import { PageHeader } from '../../../components/core/PageHeader/PageHeader';
import * as assetApi from '../../../api/app/assetApi';
import * as dashboardApi from '../../../api/app/dashboardApi';
import { useQuery } from 'react-query';
import { Loader } from '../../../components/core/Loader/Loader';
import { Asset } from '../../../types/app/asset.types';
import { useParams } from 'react-router-dom';
import { pathFullscreen, paths } from '../../../utils/core/routes';
import { Button, Tooltip } from '@mui/material';
import { useStyles } from '../PerformanceDashboard/Dashboard.styles';
import { configNoCache } from '../../../api/core/api';
import { useTranslation } from '../../../contexts/translation';
import { Lang } from '../../../types/core/lang.types';
import { Dashboard, DashboardTypes } from '../../../types/app/dashboard.types';
import { DashboardOpcSetting } from '../../../types/app/dashboardOpcSetting';
import { DashboardOpcGrid } from './DashboardOpcGrid';

export function DashboardOpc() {
  const classes = useStyles();
  const { t, changeLang, lang } = useTranslation();
  const { parentId, name, id, lang: langParam, timezone: timezoneParam } = useParams();

  const assetId = Number(parentId);
  const isFullscreen = window.location.pathname.includes('fullscreen');

  useEffect(() => {
    if (!langParam) return;
    // @ts-ignore
    changeLang(Lang[langParam]);
  }, [langParam]);

  // Asset
  const { data: assetData, isLoading: assetIsLoading } = useQuery<Asset>(
    ['asset'],
    () => assetApi.getAsset(assetId),
    configNoCache,
  );

  // Dashboard
  const { data, isLoading: dashboardIsLoading } = useQuery<Dashboard>(['dashboards', id], () =>
    dashboardApi.getDashboard(Number(id)),
  );

  const { data: dataOpcSetting } = useQuery<DashboardOpcSetting>(
    ['dashboardOpcSetting', id],
    () => dashboardApi.getDashboardOpcSetting(Number(id)),
    { enabled: !!data && data.type === DashboardTypes.OPC_DASHBOARD },
  );

  const handleOpenFullScreen = () => {
    window.open(
      `${pathFullscreen.DASHBOARD}/${assetId}/${name && encodeURIComponent(name)}${
        paths.DASHBOARD_OPC
      }/${Number(id)}/${lang}`,
      'toolbar=no,resizable=yes,location=yes',
    );
  };

  const returnEl = useMemo(() => {
    if (assetIsLoading || !assetData || !dataOpcSetting) return <Loader />;

    const fullScreenButton = (
      <Tooltip title={t('general.action-buttons.fullscreen')}>
        <Button onClick={handleOpenFullScreen} variant={'contained'}>
          Fullscreen
        </Button>
      </Tooltip>
    );

    let headerButtons: any = [];
    if (!isFullscreen) headerButtons = [fullScreenButton];

    return (
      <>
        <PageHeader
          title={''}
          itemTitle={assetData.name}
          itemClassName={classes.itemTitle}
          xs={12}
          className={classes.header}
          headlineVariant={'h2'}
          buttons={headerButtons}
        />
        <div style={{ padding: 10 }}>
          <DashboardOpcGrid
            dataOpcSetting={dataOpcSetting}
            assetId={assetId}
            assetName={assetData.name}
            isFullScreen={isFullscreen}
            lang={lang}
          />
        </div>
      </>
    );
  }, [assetData, assetIsLoading, dashboardIsLoading, lang, dataOpcSetting]);

  return <>{returnEl}</>;
}
